@if (actionConfig) {
  <oaibox-stats-card [title]="actionConfig.name" [icon]="actionConfig.icon" [gradient]="actionConfig.gradientColor">
    <div class="content">
      <form [formGroup]="uhdForm" class="form">
        <div>
          <label class="form-label">UHD Version</label>
          <input class="form-control" type="text" formControlName="uhdVersion">
        </div>
      </form>
      <p class="info"><i class="fa-solid fa-circle-info"></i> Please fill UHD version before submitting!</p>
    </div>
    <div class="modal-buttons-container p-g">
      <button class="btn btn-ignore" type="button" (click)="cancel()">Cancel</button>
      <button class="btn btn-{{actionConfig.gradientColor}} modal-confirmation-button" type="submit"
              (click)="confirmAction()" [disabled]="uhdForm.invalid">
        Update UHD Version
      </button>
    </div>
  </oaibox-stats-card>
}
